export default "__VITE_ASSET__I7JkJkCtHkb7XszFND871w__";